import {Offer, OfferState} from 'interfaces';
import {createdAtSort} from './sort';

const LAST_OFFER_STATES = [OfferState.accepted, OfferState.opened];

export function getLastOffer(offers: Offer[]) {
  const sortedOffers = offers
    .slice()
    .sort(createdAtSort)
    .reverse();

  const lastAcceptedOrOpened = sortedOffers.find((offer) =>
    LAST_OFFER_STATES.includes(offer.state));

  return lastAcceptedOrOpened || offers[offers.length - 1];
}
